import React, { useState, useRef, useEffect } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import privateApi from "../../apis/privateApi";
import { setIsLoggedIn } from "../../redux/slices/isLoggedInSlice";

const Navbar = () => {

  const isLoggedIn = useSelector((state) => state.isLoggedIn);
  const role = useSelector((state) => state.role);
  const dispatch = useDispatch();
  const roleRoutes = {
    "Super Admin": '/platform-admin-dashboard',
    organization_admin: '/organization-dashboard',
    driver: '/driver-dashboard',
  };

  const [loading, setLoading] = useState(false);
  const handleLogout = async () => {
    setLoading(true)
    await privateApi.post("/api/auth/logout");
    dispatch(setIsLoggedIn(false));
    setLoading(false)
  };

  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => setIsOpen(prev => !prev);
  const closeMenu = () => setIsOpen(false);

  // Close menu when clicking outside
  useEffect(() => {
    // console.log(role, "Groove")
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <header className="navbar">
      <div className="navbar-container" ref={menuRef}>
        <div className="navbar-logo">
          <Link to="/" onClick={closeMenu}>Budget Tracker</Link>
        </div>

        <div>
          {
            isLoggedIn ?
              <div className='navbar-action-buttons'>
                <button onClick={handleLogout} className='navbar-logout' disabled={loading}>Logout</button>
                {role && roleRoutes[role] && (<Link to={roleRoutes[role]} className='navbar-login'>Dashboard</Link>)}
              </div> :
              <div className='navbar-action-buttons'>
                <Link to={'/login'} className='navbar-login'>Login</Link>
              </div>
          }
        </div>
        <div className="navbar-toggle" onClick={toggleMenu}>
          ☰
        </div>
      </div>
    </header>
  );
};

export default Navbar;